import { useMemo } from 'react';
import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import { useHouseholdInsightsQuery } from './useHouseholdInsightsQuery.ts';

export type HouseholdInsightsParser<T> = (response: HouseholdInsightsApiResponse | undefined) => T;

/**
 * Selects one chart's data from the shared Household Insights response.
 * Pass a module-level parser from `data/parsers` (a stable reference, so parsing is memoised per response).
 *
 * @example const { data, isLoading } = useHouseholdInsightsData(parseAgeGender);
 */
export const useHouseholdInsightsData = <T>(parser: HouseholdInsightsParser<T>) => {
  const { response, isLoading } = useHouseholdInsightsQuery();
  const data = useMemo(() => parser(response), [parser, response]);

  return { data, isLoading };
};
